import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {observer, PropTypes as MobxPropTypes} from 'mobx-react';
import * as mobx from 'mobx'

import {SearchToSelect} from "../../components";

import CategoryStore from "./CategoryStore";

const GoogleCategorySelector = observer(class GoogleCategorySelector extends Component {
    static propTypes = {
        placeholder: PropTypes.string,
        selected: MobxPropTypes.arrayOrObservableArray,
        onSelect: PropTypes.func.isRequired,
        multi: PropTypes.bool,
        disabled: PropTypes.bool,
        googleCategoriesStore: PropTypes.instanceOf(CategoryStore) // Can be supplied to remove reloading of categories
    };

    constructor(props){
        super(props);
        this.props.googleCategoriesStore.loadCategories()
    }

    normalizingFunction(array) {
        return array.map(x => {
            return x.toLowerCase()
              .split(' ')
              .map((word) => {
                let coordinatingConjunctionList = ["and", "but", "for", "nor", "or", "so", "yet"]
                return coordinatingConjunctionList.includes(word.toLowerCase()) ? word : word.charAt(0).toUpperCase() + word.substring(1)
              })
              .join(' ');
        });
    }

    render() {
        //for some reason placeholder was one draw behind
        const {selected, multi, disabled, googleCategoriesStore} = this.props;
        let placeholder = "Loading...";
        if (googleCategoriesStore.isLoading) {
            placeholder = "Loading..."
        } else if(multi && selected && selected.length){
            // Multi select displays category names
            if(selected.length < 6){
                placeholder = `${selected.join(", ")}`;
            } else {
                placeholder =  `${selected.length} selections`
            }
        } else if (!multi && selected && selected.length === 1) {
            placeholder = selected[0]
        } else {
            placeholder = "Select..."
        }

        const jsCategories = mobx.toJS(googleCategoriesStore.filteredGoogleCategories);
        
        return (
            <SearchToSelect
                placeholder={this.props.placeholder || placeholder}
                maxItems={3}
                multi={multi}
                selectByKey
                disabled={disabled || googleCategoriesStore.isLoading}
                getKey={category => category.text}
                options={jsCategories}
                normalizingFunction={this.normalizingFunction}
                renderOption={category => category.text}
                renderMultiSelected={() => this.props.placeholder || placeholder || (multi ? "Categories" : "Category")}
                onSelected={this.props.onSelect}
                getSearchResults={({query}) => googleCategoriesStore.searchGoogle(query)}
                selected={selected}
            />
        );
    }
});

GoogleCategorySelector.defaultProps = {
    multi: true, // Multi select by default
    disabled: false,
    googleCategoriesStore: new CategoryStore()
};

export default GoogleCategorySelector;